<template>
  <main>
    <ProcessHeader
      :openSideBar="openSideBar"
      :isConfidential="isConfidential"
      v-bind="processDetail"
    />
    <section class="is-flex is-full-height">
      <ProcessTree
        v-if="processDetail.tree.length"
        v-model="sideBarOpen"
        :selectDocument="changeFile"
        v-bind="processDetail"
      />
      <PDFViewerMobile
        v-if="fileURL && isMobile"
        :source="fileURL"
        class="custom-viewer"
        @download="downloadOriginalFile()"
      />
      <PDFViewer
        v-else-if="fileURL"
        :fileURL="fileURL"
        :viewerRules="pdfViewerRules"
        class="mt-10"
      />
      <div
        v-else
        class="m-10 is-full has-text-centered is-align-content-center"
      >
        <CustomLoaderAnimation />
      </div>
    </section>
  </main>
</template>

<script>
import PDFViewer from "@/components/PDFViewer";
import ProcessHeader from "@/views/Process/ProcessPageHeader";
import ProcessTree from "@/views/Process/ProcessPageTree";
import ModalProcessView from "@/views/Process/ModalProcessView";
import { mapActions, mapGetters } from "vuex";
import { NUP, applyMask } from "@/utils/protocols";
import PDFViewerMobile from "pdf-viewer-vue/dist/vue2-pdf-viewer";
import CustomLoaderAnimation from "@/components/CustomLoaderAnimation";
import { downloadFileBlob } from "@/utils/fileUtility";

export default {
  name: "ProcessViewer",
  components: {
    ProcessHeader,
    ProcessTree,
    PDFViewer,
    CustomLoaderAnimation,
    PDFViewerMobile
  },
  props: {
    processId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sideBarOpen: true,
      fileURL: "",
      processDetail: {
        nup: "",
        cover: "",
        occurrency: "",
        secrecy: null,
        tree: []
      },
      modalCount: Number(localStorage.getItem("NOTICE_CHANGE_VIEWER"))
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "socketConnectionState",
      "isConfidentialCheck",
      "isMobile"
    ]),
    giveKnowledgeId() {
      return this.$route.query.give_knowledge_id;
    },
    pdfViewerRules() {
      const toolbarRule = this.isConfidential ? { toolbar: 0 } : {};
      return { navpanes: 0, ...toolbarRule };
    },
    isConfidential() {
      return this.isConfidentialCheck(this.processDetail.secrecy);
    }
  },
  watch: {
    socketConnectionState(newState) {
      newState && this.sendSocketMessage(this.isAuthenticated);
    }
  },
  async created() {
    this.checkBroadcastSocket();

    if (!this.modalCount || this.modalCount < 2) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalProcessView,
        hasModalCard: true,
        trapFocus: true,
        canCancel: false
      });
      const count = this.modalCount ? this.modalCount + 1 : 1;
      localStorage.setItem("NOTICE_CHANGE_VIEWER", count);
    }
  },
  async beforeMount() {
    const result = await this.getDetailProcessViewer({
      processId: this.processId,
      giveKnowledgeId: this.giveKnowledgeId
    });
    if (result) {
      this.processDetail = result;
      this.processDetail.nup = applyMask(NUP, this.processDetail.nup);
    } else this.$router.push("/app/processos");
  },
  destroyed() {
    this.$disconnect();
  },
  methods: {
    ...mapActions({
      requestFile: "requestProcessFileMaterialization",
      sendSocketMessage: "sendSocketMessage",
      fetchBroadcast: "fetchBroadcast",
      checkExistOpenSocket: "checkExistOpenSocket",
      getDetailProcessViewer: "getDetailProcessViewer"
    }),
    openSideBar() {
      this.sideBarOpen = true;
    },
    async changeFile(process_file_id) {
      this.fileURL = "";
      const result = await this.requestFile({
        process_file_id,
        give_knowledge_id: this.giveKnowledgeId
      });
      if (result) {
        this.fileURL = result.url_file;
      }
    },
    async connectToSocket() {
      await this.$connect();
    },
    async checkBroadcastSocket() {
      const result = await this.fetchBroadcast({
        message: { service: "get_master" }
      });
      if (result.error) {
        this.connectToSocket();
      }
      this.checkExistOpenSocket({
        connectToSocket: this.connectToSocket,
        masterSocketExists: !result.error
      });
    },

    async downloadOriginalFile() {
      downloadFileBlob({
        url: this.fileURL,
        attachment_name: "download.pdf"
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/variables";

.pdf {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  border: none;
}
@media screen and (max-width: $tablet) {
  .is-full-height {
    height: calc(100vh - 80px);
  }
}
.custom-viewer {
  height: calc(100vh - 150px);
  width: calc(100vw - 30px);
  margin: 5px 15px;
  z-index: 5;
}
</style>
